<template>
  <v-dialog v-model="showDialog" max-width="600" content-class="dialog-detail">
      <v-toolbar class="toolbar-update" dense>
        <v-toolbar-title class="text-primary fs-15">
          <strong>{{ $t('NOTIFICATION') }}</strong>
        </v-toolbar-title>
      </v-toolbar>
      <div class="content-update">
        <span v-html="contentDialog"></span>
        <div class="mt-3 d-flex justify-content-end">
          <div class="">
            <v-btn class="" block color="primary" @click="showDialog = false">
              {{ $t("IGNORE") }}
            </v-btn>
          </div>
        </div>
      </div>
    </v-dialog>
</template>
<script>
export default {
  name: "RoomUpdateDialog",
  data() {
    return {
      showDialog: false,
      contentDialog: ''
    }
  },
  methods: {
    toggleDialog(message) {
      this.contentDialog = message;
      this.showDialog = !this.showDialog;
    }
  }
};
</script>
